import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  HelpDocsJwtControllerService,
  HelpDocsJwtResponseDTO
} from '@libs/api';
import { environment } from '@portal/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HelpDocsJwtService {
  private readonly helpDocsApi = inject(HelpDocsJwtControllerService);

  constructor() {
    this.helpDocsApi.configuration.withCredentials = true;
  }

  private isHelpDocsSsoActive(): boolean {
    return environment.production;
  }

  /**
   * Calls API to generate HelpDocs JWT and set cookie via Set-Cookie header
   */
  setHelpDocsJwt(): Observable<HelpDocsJwtResponseDTO> {
    if (!this.isHelpDocsSsoActive()) {
      return of({} as HelpDocsJwtResponseDTO);
    }

    return this.helpDocsApi.helpDocsJwtControllerGenerateHelpDocsJwt();
  }

  /**
   * Clear HelpDocs JWT cookie (for logout)
   * Uses backend endpoint since cookie is HttpOnly and cannot be cleared via JavaScript
   */
  clearHelpDocsJwt(): Observable<HelpDocsJwtResponseDTO> {
    if (!this.isHelpDocsSsoActive()) {
      return of({} as HelpDocsJwtResponseDTO);
    }

    return this.helpDocsApi.helpDocsJwtControllerGenerateHelpDocsJwt({
      clear: true
    });
  }
}
